export const setAlerts = (state, alerts) => {
  state.alerts = alerts;
};

export const setSystemStatus = (state, systemStatus) => {
  state.systemStatus = systemStatus;
};

export const setAlertError = (state, error) => {
  state.alertError = error;
};
